import React from "react";
import ProfileHeader from "../Headers/ProfileHeader";

function ErrorMessage(props: {message: string, title: string, cognitoUser: any}) {
  const {message, title, cognitoUser} = props;
  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title={title} linkToHome="/home"/>
      <section className="container rounded px-0 mt-3">
        <div className="row">
          <div className="col py-4 text-center">
            <h4>
              {message}
            </h4>
          </div>
        </div>
      </section>
    </>
  );
}

export default ErrorMessage;
